import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { authData } from 'src/app/util/auth';
import { environment } from './../../../../environments/environment';
import { errorHandler } from './../../../../app/util/errorHandler';
import { StudentGuardiansDTO } from '../../../models/studentGuardianDto';

@Component({
  selector: 'app-bio-data-guardian',
  templateUrl: './bio-data-guardian.component.html',
  styleUrls: ['./bio-data-guardian.component.scss']
})
export class BioDataGuardianComponent implements OnInit {

  constructor(private httpClient: HttpClient, private router: Router) { }

  states: any = [];
  ChildLeavingWith: any = [];
  _auth = authData();
  guardian : StudentGuardiansDTO = {
    GuardianID: "",
    FamilyID: this._auth.Student.FamilyID,
    Name: "",
    PhoneNumber: "",
    RelationshipWithChild: "",
    PrimaryGuardian: false,
    HomeAddress: "",
    City: "",
    State: "",
    Email: "",
    OfficeAddress: "",
    PrimaryGuardianLabel: "No",
    ImageType: "jpeg",
    ImageUrl: this.getImageUrl(undefined),
    PassportData: "",
    ImageSize: 0
  };
  
  GuadiansDTO:StudentGuardiansDTO[] | any= [
    {
      ...this.guardian,
    },
  ];
  
  url: any = null;
  studentPassport = null;
  payload: any = {
  };

  loading = false;
  skeletonLoader = true;
  notification = {};

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this._auth.Token,
    }),
  };

  ngOnInit(): void {
    const baseUrl = `${environment.BASE_URL}/biodata/Guardians`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe(
      (res: any) => {
        this.GuadiansDTO = [...res.Data];

        this.GuadiansDTO =
          this.GuadiansDTO.map((el: any) => {
            return {
              ...el,
              FamilyID: this._auth.Student.FamilyID,
              PrimaryGuardianLabel: this.getLabel(el.PrimaryGuardian),
              ImageUrl: this.getImageUrl(el.PassportData)
            };
          });
          this.skeletonLoader = false;
      },
      (err) => {
        this.skeletonLoader = false;
      }
    );
    this.getStates();
    this.getRelationshipsWithChild();
  }

  getStates() {
    this.skeletonLoader = true;
    const baseUrl = `${environment.BASE_URL}/biodata/states`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe(
      (res: any) => {
        this.states = res.Data || [];
      },
      (err) => {
      }
    );
  }
  getImageUrl(passportData: any) {
    return passportData ?
        'data:image/png;base64,' + passportData
        : 'https://www.gravatar.com/avatar/?d=mp'
  }

  getRelationshipsWithChild() {
    this.skeletonLoader = true;
    const baseUrl = `${environment.BASE_URL}/biodata/RelationshipsWithChild`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe(
      (res: any) => {
        this.ChildLeavingWith = res.Data || [];
      },
      (err) => {
      }
    );
  }

  updateGuardians() {
    this.loading = true;
    this.notification = {};

    const baseUrl = `${environment.BASE_URL}/biodata/SaveGuardians`;
    this.httpClient.put(baseUrl, this.GuadiansDTO, this.httpOptions).subscribe(
      (res) => {
        this.router.navigateByUrl("/bio-data#Guardians+updated+successfully");
      },
      (err) => {
        this.loading = false;
        this.notification = errorHandler(err);
      }
    );
  }

  generatePreview(event: any, index: number): void {
    const file = event.target.files[0];

    if (event.target.files && file) {
      if (file.size > 2097152) {
        this.GuadiansDTO[index].ImageSize = 0;
        this.GuadiansDTO[index].ImageType = "jpeg";
        this.GuadiansDTO[index].PassportData = "";
        this.GuadiansDTO[index].ImageUrl = this.getImageUrl(undefined);
        this.payload = { ImageSize: 0, ImageType: "", PassportData: "" };
        this.notification = errorHandler({
          Message: "Image File size too large",
        });
      } else {
        const reader = new FileReader();
        reader.onload = (event: any) => {
          const name = file.name;
          const lastDot = name.lastIndexOf(".");

          this.payload = {
            ImageSize: file.size,
            ImageType: name.substring(lastDot + 1),
            PassportData: event.target.result.replace(
              /^data:image\/\w+;base64,/,
              ""
            )
          };
          
          this.GuadiansDTO[index].ImageSize = file.size;
          this.GuadiansDTO[index].ImageType = name.substring(lastDot + 1).toLowerCase();
          this.GuadiansDTO[index].PassportData = event.target.result.replace(/^data:image\/\w+;base64,/, "");
          this.GuadiansDTO[index].ImageUrl = this.getImageUrl(this.GuadiansDTO[index].PassportData);
        };

        reader.readAsDataURL(file);
      }
    }
  }

  totalGuardians(): any[] {
    return new Array(this.GuadiansDTO.length);
  }
  showGuardianList() {
    this.router.navigateByUrl("/bio-data/guardians")
  }

  addGuardian() {
    this.GuadiansDTO.push({ ...this.guardian });
  }

  removeGuardian(index: number) {
    const GuadiansDTO = [
      ...this.GuadiansDTO,
    ];

    this.GuadiansDTO = [
      ...GuadiansDTO.slice(0, index),
      ...GuadiansDTO.slice(index + 1),
    ];
  }

  toggleCheckBox(variable: string, i: number) {
    this.GuadiansDTO[i][variable] = !this.GuadiansDTO[i][variable];
    this.GuadiansDTO[i][`${variable}Label`] = this.getLabel(this.GuadiansDTO[i][variable]);
  }

  getLabel(variable: boolean) : string {
    return variable ? "Yes" : "No";
  }
}